import type { ProductModel } from '@/types/models/ProductModel'

export type ProductState = {
    products: ProductModel[]
    product?: ProductModel
}

export enum EProductActions {
    FETCH_PRODUCTS = 'fetchProducts',
    FETCH_PRODUCT = 'fetchProduct',
    CREATE_PRODUCT = 'createProduct',
    UPDATE_PRODUCT = 'updateProduct',
    DELETE_PRODUCT = 'deleteProduct',
    RESET_PRODUCT = 'resetProduct'
}

export enum EProductMutations {
    SET_PRODUCTS = 'setProducts',
    SET_PRODUCT = 'setProduct',
    SET_LOADING = 'setLoading',
    SET_PAGINATION = 'setPagination',
    REMOVE_PRODUCT = 'removeProduct',
    RESET_PRODUCT = 'resetProduct'
}
